import { render } from "./8.Products.vue?vue&type=template&id=94fc6c50&scoped=true"
import script from "./8.Products.vue?vue&type=script&lang=js"
export * from "./8.Products.vue?vue&type=script&lang=js"

import "./8.Products.vue?vue&type=style&index=0&id=94fc6c50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94fc6c50"]])

export default __exports__